'use strict'

class HotWell {
	constructor(well) {
		this.well = well
	}
}

export {HotWell}